import { createAction } from "@reduxjs/toolkit";
import { Features } from "../reducers/featuresReducer";

export const setFeature = createAction<{ readonly [K in Features]?: boolean }>(
  "features/set-feature-flag"
);
